import styled from 'styled-components';
import { MTextBlockFullAlignment } from './MTextBlockFull.types';

interface WrapperProps {
  $alignment: MTextBlockFullAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $alignment }) => ($alignment === MTextBlockFullAlignment.Centered ? 'center' : 'flex-start')};
  text-align: ${({ $alignment }) => ($alignment === MTextBlockFullAlignment.Centered ? 'center' : 'left')};
  width: 100%;
`;

export const EyebrowWrapper = styled.div`
  margin-block-end: 0.5rem;
`;

export const HeaderWrapper = styled.div`
  margin-block-end: 1rem;
`;

export const AccentLineWrapper = styled.div`
  margin-block-end: 1rem;
  width: 100%;
`;

export const SubheaderWrapper = styled.div`
  margin-block-end: 1rem;
`;

export const BodyWrapper = styled.div`
  margin-block-end: 0;
`;
